import PropTypes from 'prop-types';

import { Abstrap } from '..';

const propTypes = { ...Abstrap.propTypes, inner: PropTypes.bool };

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'div',
    inner: false,
};

class Hr extends Abstrap {

    getClassNameSchema() {
        const {
            className,
            inner,
        } = this.props;
        return [
            's-hr',
            inner ? 's-hr--inner' : false,
            className,
        ];
    }

}

Hr.propTypes = propTypes;

Hr.defaultProps = defaultProps;

export default Hr;
